import { Helmet } from "react-helmet-async";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";
import Breadcrumb from "../../../component/Breadcrumb";

export default function UberEatsBanner({data}) {
  const dispatch = useDispatch();
  return (
    <>
    <Helmet>
      <link rel="preload" href={data?.image} as="image" type="image/webp"/>
    </Helmet>
      <section className="lyftclone-banner uber-eats-banner header-gap">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-head">
                <Breadcrumb breadcrumbData={data?.breadcrumbData}/>
                <h1 className="heading">{data?.heading}</h1>
                <p>{data?.desc}</p>
                <div className="free-trial">21 Days Free Trial | No Credit Card Required</div>
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data?.cta}</button>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-image">
                <img src={data?.image} alt="uber eats Clone" className="img-responsive" />
                <div className="lyft-banner-animate-box"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
